<template>
    <div class="tree-map">
        <div class="tree-map-chart" ref="tree"></div>
    </div>
</template>

<script>
import { sortByKey } from '../../assets/js/utils'
import event from '../event'
export default {
    props: {
        treeMapData: Array,
        cur: Number
    },
    data() {
        return {
            pos: '',
            borderColor:'1b1b1b'
        }
    },
    created(){
        // var url = window.location.href;
        var url = document.referrer
        var a = url.split('?')
        var b = a[1].split('&')
        var theme = null
        for(let i = 0; i<b.length; i++){
            let arr = b[i].split('=');
            if(arr[0].replace(/(^\s*)|(\s*$)/g,'')== 'theme'){
                theme=arr[1]
            }
        }
        if(theme == 'newblack'){
            this.borderColor='#fff'
            }else if(theme == 'newgrey'){
            this.borderColor='#181c21'
            }else{
            this.borderColor='#1b1b1b'
            }
    },
    mounted() {
        this.initChart(this.treeMapData)
    },
    watch: {
        treeMapData(val) {
            this.initChart(val)
        }
    },
    methods: {
        initChart(treeMapData) {
            let el = this.$refs.tree
            let chart = window.echarts.init(el)
            let data = []
            let colorData = []
            // let absData = []
            // let colorValue = []
            for (let i = 0; i < 20; i++) {
                let _value
                if (this.cur === 0) {
                    _value = treeMapData[i] ? treeMapData[i].inflow : ''
                } else if (this.cur === 1) {
                    _value = treeMapData[i] ? treeMapData[i].five_inflow : ''
                } else {
                    _value = treeMapData[i] ? treeMapData[i].twenty_inflow : ''
                }
                data.push({
                    name: i,
                    value: Math.abs(_value),
                    $code: treeMapData[i].code,
                    $curInflow: treeMapData[i].curInflow,
                    $change: treeMapData[i].change,
                    $name: treeMapData[i].name,
                    label: {
                        formatter: () => {
                            return treeMapData[i].name
                        },
                        color: '#fefefe',
                        fontFamily: 'SimSun'
                    }
                })
                _value > 0 ? 
                    colorData.push({
                        // color: '#c63031',
                        key: i,
                        value: Math.abs(_value)
                    }) : 
                    colorData.push({
                        // color: '#22ac38', 
                        key: i,
                        value: Math.abs(_value)
                    })
            }
            let _colorData = colorData.sort(sortByKey('value', false))
            let color = []
            for (let i = 0; i < 20; i++) {
                let curColor = _colorData[i].key < 10 ? 'rgba(198,48,49, 0.8)' : 'rgba(34,172,56, 0.8)'
                color.push(curColor)
            }
            chart.setOption({
                animation: false,
                color: color,
                tooltip: {},
                series: [{
                    type: 'treemap',
                    nodeClick: false,
                    width: '100%',
                    height: '100%',
                    roam: false,
                    itemStyle: {
                        gapWidth: 3,
                        borderColor: this.borderColor,
                    },
                    breadcrumb: {
                        show: false
                    },
                    data: data,
                    tooltip: {
                        formatter: (params) => {
                            // 埋点 
                            if (params.treePathInfo[1] && params.treePathInfo[1].dataIndex != this.pos) {
                                this.pos = params.treePathInfo[1].dataIndex
                                window.TA.log({
                                    id: `webhsgt_list_hover_${this.pos}`
                                })
                            }
                            let i = params.data.name
                            let zdf = ''
                            if (this.cur === 0) {
                                zdf = treeMapData[i] ? treeMapData[i].change : ''
                            } else if (this.cur === 1) {
                                zdf = treeMapData[i] ? treeMapData[i].five_change : ''
                            } else {
                                zdf = treeMapData[i] ? treeMapData[i].twenty_change : ''
                            }
                            if (i || i === 0) {
                                return `<div style="font-family:SimSun;">
                                    <div>${treeMapData[i].name}</div>
                                    <div>累计流入:${(treeMapData[i].curInflow/1e8).toFixed(2)}亿</div>
                                    <div>涨跌幅:${/* treeMapData[i].change */zdf}%</div>
                                </div>`
                            }
                        },
                        confine: true
                    }
                }]
            })
            chart.on('click', function(params) {
                if(params.treePathInfo.length === 2) {
                    event.set('treeMapData', params.data)
                    let pos = params.treePathInfo[1].dataIndex
                    window.TA.log({
                        id: `webhsgt_list_click_${pos}`
                    })
                }
            })
        }
    }
}
</script>

<style lang="less">
.tree-map {
    height: 375px;
    padding-left: 6px;
    .tree-map-chart {
        width: 100%;
        height: 445px;
    }
}
</style>
